var $b2c2b4430b10cd26$exports = {};
const $b2c2b4430b10cd26$var$iconElement = document.getElementById("hamburger-icon-js");
const $b2c2b4430b10cd26$var$menuElement = document.getElementById("hamburger-menu-js");
$b2c2b4430b10cd26$var$iconElement.addEventListener("click", ()=>{
    const isOpen = $b2c2b4430b10cd26$var$menuElement.dataset.isOpen;
    if (isOpen === "true") {
        $b2c2b4430b10cd26$var$iconElement.dataset.isOpen = "false";
        $b2c2b4430b10cd26$var$menuElement.dataset.isOpen = "false";
    } else {
        $b2c2b4430b10cd26$var$iconElement.dataset.isOpen = "true";
        $b2c2b4430b10cd26$var$menuElement.dataset.isOpen = "true";
    }
});
const $b2c2b4430b10cd26$var$menuItems = document.querySelectorAll(".hamburger-menu__item");
for(let i = 0; i < $b2c2b4430b10cd26$var$menuItems.length; i++)$b2c2b4430b10cd26$var$menuItems[i].addEventListener("click", ()=>{
    if ($b2c2b4430b10cd26$var$menuItems[i].dataset.link) window.location.href = $b2c2b4430b10cd26$var$menuItems[i].dataset.link;
    $b2c2b4430b10cd26$var$iconElement.dataset.isOpen = "false";
    $b2c2b4430b10cd26$var$menuElement.dataset.isOpen = "false";
});
document.addEventListener("click", (event)=>{
    if (!$b2c2b4430b10cd26$var$menuElement.contains(event.target) && !$b2c2b4430b10cd26$var$iconElement.contains(event.target)) {
        const isOpen = $b2c2b4430b10cd26$var$menuElement.dataset.isOpen;
        if (isOpen === "true") {
            $b2c2b4430b10cd26$var$iconElement.dataset.isOpen = "false";
            $b2c2b4430b10cd26$var$menuElement.dataset.isOpen = "false";
        }
    }
});


//# sourceMappingURL=index.b217cd18.js.map
